module.exports = __webpack_public_path__ + "static/media/gym-left-min.9a482a32.jpg";